import { render } from "./ProjectActivityInfo.vue?vue&type=template&id=261d3c40&scoped=true"
import script from "./ProjectActivityInfo.vue?vue&type=script&lang=js"
export * from "./ProjectActivityInfo.vue?vue&type=script&lang=js"

import "./ProjectActivityInfo.vue?vue&type=style&index=0&id=261d3c40&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261d3c40"]])

export default __exports__